import React from 'react'
import { Skeleton } from '@mui/material'

export const ActionButtonsSkeleton = () => {
  const count = 4

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          width={150}
          height={36.5}
          animation='wave'
          variant='rounded'
        />
      ))}
    </>
  )
}
